import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders a fieldset element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the fieldset.
 * @param {Object} [props.children] - Child elements to be rendered inside the fieldset.
 * @returns {JSX.Element} The rendered fieldset component.
 */
export function Fieldset({ className, ...props }) {
  return (
    <Headless.Fieldset
      {...props}
      className={clsx(
        className,
        '[&>*+[data-slot=control]]:mt-6 [&>[data-slot=text]]:mt-1'
      )}
    />
  );
}

Fieldset.propTypes = {
  className: PropTypes.string,
};
